module.exports = __webpack_public_path__ + "static/EtechLogo.9fb57f73.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/EtechLogo.png
// module id = 483
// module chunks = 79611799117203